export const PERSONAL_VALUE_GROUPS = [
  {
    id: "self",
    label: "Я и внутренний мир",
    values: [
      { id: "acceptance", label: "Принятие другими", description: "Быть принятым таким, какой я есть." },
      { id: "accuracy", label: "Точность", description: "Быть точным в своих мнениях и убеждениях." },
      { id: "autonomy", label: "Автономность", description: "Самостоятельно определять свою жизнь." },
      { id: "genuineness", label: "Подлинность", description: "Действовать в согласии с тем, кто я есть." },
      { id: "gods-will", label: "Воля Бога", description: "Искать и исполнять волю Бога." },
      { id: "honesty", label: "Честность", description: "Быть честным и говорить правду." },
      { id: "hope", label: "Надежда", description: "Сохранять позитивный и оптимистичный взгляд." },
      { id: "humility", label: "Смирение", description: "Быть скромным и непритязательным." },
      { id: "inner-peace", label: "Внутренний покой", description: "Ощущать душевное спокойствие." },
      { id: "mindfulness", label: "Осознанность", description: "Жить внимательно к настоящему моменту." },
      { id: "moderation", label: "Умеренность", description: "Избегать излишеств и находить середину." },
      { id: "purpose", label: "Предназначение", description: "Иметь смысл и направление в жизни." },
      { id: "rationality", label: "Рациональность", description: "Руководствоваться разумом и логикой." },
      { id: "realism", label: "Реализм", description: "Видеть ситуацию и действовать практично." },
      { id: "self-acceptance", label: "Самопринятие", description: "Принимать себя таким, какой я есть." },
      { id: "self-control", label: "Самоконтроль", description: "Управлять собственными действиями." },
      { id: "self-esteem", label: "Самоуважение", description: "Хорошо относиться к себе." },
      { id: "self-knowledge", label: "Самопознание", description: "Глубоко и честно понимать себя." },
      { id: "simplicity", label: "Простота", description: "Жить просто, без лишних потребностей." },
      { id: "solitude", label: "Уединение", description: "Иметь время и пространство наедине с собой." },
      { id: "spirituality", label: "Духовность", description: "Расти и развиваться духовно." },
      { id: "virtue", label: "Добродетель", description: "Жить нравственно и достойно." },
    ],
  },
  {
    id: "growth",
    label: "Развитие и достижения",
    values: [
      { id: "achievement", label: "Достижения", description: "Добиваться значимых результатов." },
      { id: "challenge", label: "Вызов", description: "Браться за сложные задачи и проблемы." },
      { id: "creativity", label: "Творчество", description: "Создавать новые и оригинальные идеи." },
      { id: "duty", label: "Долг", description: "Исполнять свои обязанности." },
      { id: "growth", label: "Развитие", description: "Продолжать меняться и расти." },
      { id: "industry", label: "Трудолюбие", description: "Работать усердно и качественно." },
      { id: "knowledge", label: "Знания", description: "Учиться и создавать ценные знания." },
      { id: "mastery", label: "Мастерство", description: "Быть компетентным в повседневных делах." },
      { id: "responsibility", label: "Ответственность", description: "Принимать и выполнять ответственные решения." },
    ],
  },
  {
    id: "freedom",
    label: "Свобода и впечатления",
    values: [
      { id: "adventure", label: "Приключения", description: "Получать новый и захватывающий опыт." },
      { id: "change", label: "Перемены", description: "Жить жизнью, полной изменений и разнообразия." },
      { id: "excitement", label: "Яркие впечатления", description: "Испытывать сильные эмоции и стимулы." },
      { id: "flexibility", label: "Гибкость", description: "Легко приспосабливаться к новым обстоятельствам." },
      { id: "independence", label: "Независимость", description: "Не зависеть от других." },
      { id: "non-conformity", label: "Нонконформизм", description: "Ставить под вопрос нормы и авторитеты." },
      { id: "openness", label: "Открытость", description: "Быть открытым новому опыту, идеям и вариантам." },
      { id: "passion", label: "Страсть", description: "Глубоко чувствовать идеи, занятия и отношения." },
      { id: "pleasure", label: "Удовольствие", description: "Получать приятные ощущения." },
      { id: "risk", label: "Риск", description: "Рисковать и использовать возможности." },
      { id: "fun", label: "Веселье", description: "Играть, смеяться и получать удовольствие." },
    ],
  },
  {
    id: "relationships",
    label: "Отношения и забота",
    values: [
      { id: "caring", label: "Забота", description: "Заботиться о других людях." },
      { id: "commitment", label: "Обязательства", description: "Брать на себя длительные и значимые обязательства." },
      { id: "compassion", label: "Сострадание", description: "Чувствовать участие и действовать ради других." },
      { id: "cooperation", label: "Сотрудничество", description: "Работать вместе с другими." },
      { id: "courtesy", label: "Вежливость", description: "Быть внимательным и вежливым с людьми." },
      { id: "dependability", label: "Надёжность", description: "Быть человеком, на которого можно положиться." },
      { id: "faithfulness", label: "Верность", description: "Быть преданным и честным в отношениях." },
      { id: "family", label: "Семья", description: "Иметь счастливую и любящую семью." },
      { id: "forgiveness", label: "Прощение", description: "Уметь прощать других." },
      { id: "friendship", label: "Дружба", description: "Иметь близких и поддерживающих друзей." },
      { id: "generosity", label: "Щедрость", description: "Делиться с другими тем, что у меня есть." },
      { id: "helpfulness", label: "Помощь другим", description: "Быть полезным другим людям." },
      { id: "intimacy", label: "Близость", description: "Делиться с другими самыми личными переживаниями." },
      { id: "loved", label: "Быть любимым", description: "Получать любовь от близких людей." },
      { id: "loving", label: "Любовь к другим", description: "Дарить любовь другим людям." },
      { id: "monogamy", label: "Моногамия", description: "Иметь одни близкие и любящие отношения." },
      { id: "nurturance", label: "Поддержка и развитие других", description: "Заботиться о людях и помогать им расти." },
      { id: "romance", label: "Романтика", description: "Иметь яркую и волнующую любовь." },
      { id: "service", label: "Служение", description: "Служить и приносить пользу другим." },
      { id: "sexuality", label: "Сексуальность", description: "Иметь активную и удовлетворяющую сексуальную жизнь." },
      { id: "tolerance", label: "Толерантность", description: "Принимать и уважать тех, кто отличается от меня." },
    ],
  },
  {
    id: "wellbeing",
    label: "Образ жизни и благополучие",
    values: [
      { id: "attractiveness", label: "Привлекательность", description: "Быть физически привлекательным." },
      { id: "beauty", label: "Красота", description: "Замечать и ценить красоту вокруг." },
      { id: "comfort", label: "Комфорт", description: "Жить приятной и удобной жизнью." },
      { id: "ecology", label: "Экология", description: "Жить в гармонии с окружающей средой." },
      { id: "fitness", label: "Физическая форма", description: "Быть физически подготовленным и сильным." },
      { id: "health", label: "Здоровье", description: "Быть физически здоровым." },
      { id: "humor", label: "Юмор", description: "Видеть смешную сторону себя и мира." },
      { id: "leisure", label: "Досуг", description: "Находить время для отдыха и удовольствия." },
      { id: "order", label: "Порядок", description: "Жить организованной и упорядоченной жизнью." },
      { id: "safety", label: "Безопасность", description: "Чувствовать себя защищённым." },
      { id: "stability", label: "Стабильность", description: "Иметь достаточно постоянную жизнь." },
    ],
  },
  {
    id: "society",
    label: "Влияние и общество",
    values: [
      { id: "authority", label: "Авторитет", description: "Руководить другими и отвечать за них." },
      { id: "contribution", label: "Вклад", description: "Оставить значимый след в мире." },
      { id: "fame", label: "Известность", description: "Быть известным и признанным." },
      { id: "justice", label: "Справедливость", description: "Продвигать равное и справедливое отношение ко всем." },
      { id: "popularity", label: "Популярность", description: "Нравиться многим людям." },
      { id: "power", label: "Власть", description: "Иметь контроль над другими." },
      { id: "tradition", label: "Традиции", description: "Следовать уважаемым образцам прошлого." },
      { id: "wealth", label: "Богатство", description: "Иметь много денег." },
      { id: "world-peace", label: "Мир во всём мире", description: "Способствовать миру во всём мире." },
    ],
  },
];

export const PERSONAL_VALUES = PERSONAL_VALUE_GROUPS.flatMap((group) => (
  group.values.map((value) => ({ ...value, groupId: group.id, groupLabel: group.label }))
));

export const PERSONAL_VALUE_IDS = new Set(PERSONAL_VALUES.map((value) => value.id));
